import React from 'react'

export const WaitingIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='5.5' y='6' width='13' height='13' rx='6.5' stroke='currentColor' />
      <path
        d='M12.5 9.5C12.5 9.22386 12.2761 9 12 9C11.7239 9 11.5 9.22386 11.5 9.5L12.5 9.5ZM12 9.5L11.5 9.5L11.5 13.5L12 13.5L12.5 13.5L12.5 9.5L12 9.5Z'
        fill='currentColor'
      />
      <path
        d='M15.5 13.5C15.7761 13.5 16 13.2761 16 13C16 12.7239 15.7761 12.5 15.5 12.5L15.5 13.5ZM15.5 13L15.5 12.5L11.5 12.5L11.5 13L11.5 13.5L15.5 13.5L15.5 13Z'
        fill='currentColor'
      />
    </svg>
  )
}
